import { withStyles } from '@material-ui/styles';
import ProfileForm from './ProfileForm';
import styles from './styles';

export default withStyles(styles)(ProfileForm);
